import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  bottomSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 32,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  bottomSectionInner: {
    padding: '24px 32px 24px 32px',
    display: 'flex',
    flexDirection: 'row',
    gap: 32,
    alignItems: 'center',
  },
  footerUserInfo: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    minWidth: '20%',
  },
  clickable: {
    cursor: 'pointer',
  },
  footerNickName: {
    fontWeight: 600,
    lineHeight: '20px',
    display: 'block',
  },
  footerFullName: {
    fontWeight: 500,
    lineHeight: '20px',
    color: colors.neutral600,
  },
  footerBadge: {
    marginTop: 4,
    borderRadius: 99,
    height: 22,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '20px',
    padding: '0 8px',
    color: colors.indigo600,
    background: colors.indigo50,
    borderColor: colors.indigo50,
  },
  bottomText: {
    fontWeight: '600',
    color: colors.neutral700,
    lineHeight: '20px',
  },
  alertText: {
    color: colors.destructive600,
  },
  bottomIcon: {
    height: 16,
    width: 16,
  },
  bottomContentWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
});
